import React from "react";
import "antd/dist/reset.css";
import '../../styles/App.css';

import { Col, Row } from "antd";

export const ParagraphHeader = ({header}) => {
 
  return (
    <>
        <Row>
            <Col xs={24}>
                <div className="public-portal-section center-align">
                    <h2> {header}</h2>
                </div>
            </Col>
        </Row>
    </>
  );
}